/** Go to another page of the app (a full load: the page's state is read
 *  again there). One place, so a page's actions can be tested. */
export function navigateTo(url: string): void {
  window.location.assign(url);
}
